import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { rejectBody } from '../../utils/apiError';

export const fetchGarages = createAsyncThunk('garages/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get('/api/super-admin/garages');
    return response.data;
  } catch (error) {
    return rejectWithValue(rejectBody(error));
  }
});

export const createGarage = createAsyncThunk('garages/create', async (garageData, { rejectWithValue }) => {
  try {
    // Check if garageData is FormData (for file uploads)
    const config = garageData instanceof FormData ? {
      headers: { 'Content-Type': 'multipart/form-data' }
    } : {};
    
    const response = await axios.post('/api/super-admin/garages', garageData, config);
    return response.data;
  } catch (error) {
    return rejectWithValue(rejectBody(error));
  }
});

export const updateGarage = createAsyncThunk('garages/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    console.log('updateGarage thunk - id:', id);
    console.log('updateGarage thunk - data:', data);
    console.log('updateGarage thunk - data is FormData:', data instanceof FormData);
    
    // Check if data is FormData (for file uploads)
    const config = data instanceof FormData ? {
      headers: { 'Content-Type': 'multipart/form-data' }
    } : {};
    
    console.log('updateGarage thunk - making PUT request to:', `/api/super-admin/garages/${id}`);
    const response = await axios.put(`/api/super-admin/garages/${id}`, data, config);
    console.log('updateGarage thunk - response:', response.data);
    return response.data;
  } catch (error) {
    console.error('updateGarage thunk - error:', error);
    return rejectWithValue(rejectBody(error));
  }
});

export const deleteGarage = createAsyncThunk('garages/delete', async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`/api/super-admin/garages/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(rejectBody(error));
  }
});

const garagesSlice = createSlice({
  name: 'garages',
  initialState: {
    garages: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGarages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGarages.fulfilled, (state, action) => {
        state.loading = false;
        // Safely handle if data is nested or direct array
        const data = action.payload?.data || action.payload || [];
        state.garages = Array.isArray(data) ? data : [];
      })
      .addCase(fetchGarages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || action.payload?.message || action.error.message;
        state.garages = []; // Ensure garages is an array even on error
      })
      .addCase(createGarage.fulfilled, (state, action) => {
        state.garages.push(action.payload);
      })
      .addCase(updateGarage.fulfilled, (state, action) => {
        const index = state.garages.findIndex((g) => g.id === action.payload.id);
        if (index !== -1) {
          state.garages[index] = action.payload;
        }
      })
      .addCase(deleteGarage.fulfilled, (state, action) => {
        state.garages = state.garages.filter((g) => g.id !== action.payload);
      });
  },
});

export default garagesSlice.reducer;
